import {Inject, Injectable, Optional} from '@angular/core';
import { environment } from 'src/environments/environment';
import { IamService } from '../iam/api/iam.service';
import { Observable, of, switchMap } from 'rxjs';


@Injectable()
export class AuthUserService {

  private basePath = environment.basePathOrquestrador;

  constructor(protected iamService: IamService, @Optional() @Inject('basePath') basePath: string) {
    if (basePath) {
      this.basePath = basePath;
    }
  }

  public logout(){
    sessionStorage.clear();
    localStorage.clear();
  }

  isUserLoggedIn() {
    let user = sessionStorage.getItem('JWTToken');
    let cargo = sessionStorage.getItem('cargo');
    return !(user === null || cargo === null)
  }

  renewToken(token): Observable<any> {
    return this.iamService.changeAccount(token).pipe(
      switchMap(response => {
        const tokenIam = response.body.accessToken;
        sessionStorage.setItem("JWTToken", tokenIam);
        return of(response);
      })
    );
  }

  // isLoggedIn(){
  //   return tokenNotExpired();
  //
  //   // let jwtHelper = new JwtHelper();
  //   // let token = sessionStorage.getItem('token');
  //   //
  //   // if(!token)
  //   //   return false;
  //   //
  //   // let expirationDate =  jwtHelper.getTokenExpirationDate(token);
  //   // let isExpired = jwtHelper.isTokenExpired(token);
  //   // console.log("Expiration:", expirationDate);
  //   // console.log("isExpired:", isExpired);
  //   // return !isExpired;
  // }

}
